<template>
  <div class='add-integration-layout'>
    <div class='add-integration-layout__header'>
      <div @click="backToIntegrations" class="add-integration-layout__header__back">
        <v-icon class="back-icon">arrow_back</v-icon>
        <div>{{ $t('back.to.integration.list') }}</div>
      </div>
      <div class='add-integration-layout__header__title'>
        {{ $t('add.integration.layout.title') }}
      </div>
      <div class='add-integration-layout__header__search'>
        <filtered-search
          @searchInput="searchChange"
          :show-filters="false"
          :searchItem='search'
        />
      </div>
    </div>
    <div class='add-integration-layout__content'>
      <integration-widget
        v-for='(item, index) in integrationOptionsListFiltered'
        :key='index'
        :integration-data='item'
        class='integration-widget'
        @integrationClicked='integrationClicked'
        />
    </div>
    <add-integration-details-popup
      :visible-popup='showIntegrationDetailsPopup'
      @closed='showIntegrationDetailsPopup = false'
      @save='saveIntegration'
    />
  </div>
</template>

<script>
import {
  LOAD_INTEGRATION_DETAILS,
  LOAD_INTEGRATION_OPTIONS_LIST,
  SAVE_INTEGRATION,
} from '@/store/integration/actionTypes';
import { mapGetters } from 'vuex';
import IntegrationWidget from '@/components/integration/IntegrationWidget.vue';
import AddIntegrationDetailsPopup from '@/components/popup/AddIntegrationDetailsPopup.vue';
import { views } from '@/router/constants';
import FilteredSearch from '@/components/common/FilteredSearch.vue';

export default {
  name: 'AddIntegrationLayout',
  async mounted() {
    await this.$store.dispatch(LOAD_INTEGRATION_OPTIONS_LIST);
  },
  components: {
    FilteredSearch,
    AddIntegrationDetailsPopup,
    IntegrationWidget,
  },
  data() {
    return {
      showIntegrationDetailsPopup: false,
      search: '',
    };
  },
  computed: {
    ...mapGetters(['integrationOptionsList']),
    integrationOptionsListFiltered() {
      return this.integrationOptionsList.filter(integration => integration.category.toLowerCase().includes(this.search) || integration.displayName.toLowerCase().includes(this.search));
    },
  },
  methods: {
    searchChange(e) {
      this.search = e.trim();
    },
    async saveIntegration(integrationData) {
      await this.$store.dispatch(SAVE_INTEGRATION, integrationData);
      this.showIntegrationDetailsPopup = false;
      this.$router.back();
    },
    backToIntegrations() {
      this.$router.push({ name: views.INTEGRATIONS });
    },
    async integrationClicked(integrationDetails) {
      await this.$store.dispatch(LOAD_INTEGRATION_DETAILS, { name: integrationDetails.name });
      this.showIntegrationDetailsPopup = true;
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.add-integration-layout {
  padding: rem(32);
  &__header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &__title {
      margin-bottom: rem(30);
      color: var(--text-primary);
      font-family: $font-family-bold;
      font-size: rem(22);
      font-weight: bold;
      line-height: rem(20);
      letter-spacing: 0;
    }
    &__search {
      width: rem(700);
      margin-bottom: rem(15);
    }
    &__back {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: var(--brand-primary);
      cursor: pointer;
      font-family: $font-family-medium;
      font-size: rem(12);
      font-weight: 500;
      letter-spacing: rem(1.07);
      line-height: rem(16);
      text-align: center;
      text-transform: uppercase;
      margin-bottom: rem(40);
      .back-icon {
        margin-right: rem(6);
        color: var(--brand-primary);
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
  &__content {
    padding-right: rem(150);
    display: flex;
    flex-wrap: wrap;
    flex-direction: row !important;
    .integration-widget {
      margin: rem(30);
    }
  }
}
</style>
